<section class="container">
  <header class="d-flex justify-content-between align-items-end mb-4 flex-wrap">
    @if (block().title; as title) {
      <h1 class="h3 mb-1" [class.sr-only]="block().news?.length === 1">{{ title }}</h1>
    }

    <a class="button button-link button--primary h-auto" [routerLink]="['/nieuws']">
      {{ 'contentblok-nieuws-link-tekst' | fromDictionary }}
    </a>
  </header>

  @if (block().news?.length === 1) {
    <div class="news-container">
      <app-news-card class="d-block z-2 position-relative" [news]="block().news![0]"></app-news-card>
    </div>
  } @else {
    <ul class="news-grid z-2 position-relative" [class.has--grid]="(block().news?.length || 0) > 2">
      @for (newsItem of block().news | slice: 0 : 3; track newsItem.id) {
        <li class="news-grid__item">
          <app-news-list-card [news]="newsItem"></app-news-list-card>
        </li>
      }
    </ul>

    <!--<ul class="row gutter-2 gutter-sm-3">
        @for (newsItem of block().news; track newsItem.id) {
          <li class="col-md-12">
            <app-news-list-card [news]="newsItem"></app-news-list-card>
          </li>
        }
      </ul>-->
  }
</section>
